// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"47":"0dbb1607","48":"40c932bd","922":"0a0db791"}[chunkId] + ".css";
};